import { zIndexes } from "@huub-web/ui/theme/zIndex";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { responsive } from "@huub-web/ui/utils/responsive";
import { style, styleVariants } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

export const containerStyle = style({
  padding: theme.spacings.m,
  position: "sticky",
  bottom: 0,
  zIndex: zIndexes.navigation + 1,
  ...responsive({
    1000: {
      bottom: rem(8),
    },
  }),
});

export const variantStyles = styleVariants({
  info: {
    backgroundColor: theme.colors.primary,
    color: theme.colors.onPrimary,
  },
  error: {
    backgroundColor: theme.colors.error,
    color: theme.colors.onError,
  },
});
